import React, { Component } from "react";
import { formatoSeparadorMiles, formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import ReactTooltip from "react-tooltip";
import $ from "jquery";

export default class InputText extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            size: props.size,
            title: props.title,
            hidden: props.hidden,
            editable: props.editable,
            type: props.type,
            label: props.label,
            minValue: props.minValue,
            maxValue: props.maxValue,
            minLength: props.minLength,
            maxLenght: props.maxLenght,
            required: props.required,
            nullable: props.nullable,
            debitable: props.debitable,
            format: props.format,
            value: undefined
        }

    };


    componentDidMount() {

    }

    handleChange = (e) => {
        //console.log("cambio")
    //    console.log(e.target.value)
        
        $('#idSicoopPaso1').on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) { 
                e.preventDefault();
                return false;
            }
        });
        if (this.props.required && e.target.value === null) {
            this.props.inputValue(e.target.value, this.props.name, false,"",this.props.format, this.props.label, this.props.required, this.props.minLength);
            return;
        }

        let validacion = this.props.validationRegexp;
        if( validacion !== '' && validacion !== null && validacion !== 'null' ){
            try {
                let regex = new RegExp(validacion);
                if( !regex.test(e.target.value) ){
                    if( this.props.errorMessage !== '' ){
                        this.props.inputValue(e.target.value, this.props.name, true,this.props.errorMessage,this.props.format, this.props.label, this.props.required, this.props.minLength);
                    }else{
                        this.props.inputValue(e.target.value, this.props.name, true,"Formato no válido",this.props.format, this.props.label, this.props.required, this.props.minLength);
                    }
                    return;
                }
            } catch (error) {
                console.log(error);
            }
        }
        if( e.target.value.length > this.props.size ){
            this.props.inputValue(e.target.value,this.props.name,true,"Límite de caracteres excedido",this.props.format,this.props.label,this.props.required,this.props.minLength);
        }else{
            this.props.inputValue(e.target.value,this.props.name,false,"",this.props.format,this.props.label,this.props.required,this.props.minLength);
        }
        
    }

    verificarTipo() {
        if (this.props.type === "INT" || this.props.type === "LONG")
            return (<input type="number" className="form-control input-box" name={this.props.name} size={this.props.size}
                placeholder={this.props.label} maxlength={this.props.size} defaultValue={this.props.value}
                onChange={(e) => { this.handleChange(e) }} style={{textTransform: "lowercase"}}/>)

        if (this.props.type === "MONEY")
            return (<input type="text" className="form-control input-box" name={this.props.name} size={this.props.size} required={this.props.required}
                placeholder={this.props.label}  defaultValue={formatoSeparadorMilesValue(this.props.value)} onKeyUp= {formatoSeparadorMiles}
                onChange={(e) => { this.handleChange(e) }} style={{textTransform: "lowercase"}}/>)
        else
            return (<input type="text" className="form-control input-box" name={this.props.name} size={this.props.size} required={this.props.required}
                placeholder={this.props.label} minlength={this.props.minLength} maxlength={this.props.size} defaultValue={this.props.value}
                onChange={(e) => { this.handleChange(e) }} style={{textTransform: "lowercase"}}/>)

    }



    render() {


        return (
            <div className="form-group">
                <label className="input-label" data-tip={this.props.hint === '' ? this.props.title : this.props.hint} >
                    <i className="fas fa-question-circle" style={{fontSize:"25px",color:"#9c9c9c"}}></i> {this.props.label}
                </label>
                {this.verificarTipo()}
                <ReactTooltip/>
            </div>
        )

    }
}